export class RedesVamEntity {
  constructor(
    public NombreRed?: string,
    public LinkRed?: string,
    public PrimerTelefonoRed?: string,
    public SegundoTelefonoRed?: string,
    public NombrePlan?: string,
    public CodigoRamo?: string,
    public CodigoUnico?: number,
    public Ciudad?: string
  ) {}
}

export class PlanVamEntity {
  constructor(
    public NombrePlan?: string,
    public CodigoPlan?: number,
    public CodigoRamo?: string,
    public BeneficiosPlan?: BeneficiosPlan
  ) {}
}
export class BeneficiosPlan {
  constructor(
    public Coberturas?: Detalles[],
    public Deducibles?: Detalles[],
    public Carencias?: Detalles[],
    public Maternidades?: Detalles[],
    public CondicionesEspeciales?: Detalles[],
    public CondicionesEspecialesTitular?: Detalles[],
    public CondicionesEspecialesDependiente?: Detalles[],
    public CondicionesDiferenciales?: Detalles[],
    public MedicoADomicilio?: ServiciosAseguradora[]
  ) {}
}
export class ServiciosAseguradora {
  constructor(
    public CodigoServicio?: number,
    public CodigoAseguradora?: number,
    public Nombre?: string,
    public Telefono?: string,
    public ValorFee?: number,
    public TipoServicio?: number,
    public CodigoPlan?: number,
  ) {}
}
export class Detalles {
  constructor(public Nombre?: string, public Descripcion?: string) {}
}

export class DependientesVam {
  constructor(
    public CodigoDependiente?: number,
    public PrimerNombre?: string,
    public SegundoNombre?: string,
    public ApellidoPaterno?: string,
    public ApellidoMaterno?: string,
    public CodRelDep?: number,
    public Relacion?: string,
    public FechaNacimiento?: string
  ) {}
}

export class VamBancosEntity {
  constructor(public CodigoBanco?: number, public NombreBanco?: string) {}
}

export class DevolucionSeguroTitularVam {
  constructor(
    public CodigoCiudad?: number,
    public CodigoCliente?: number,
    public CodigoTitular?: number,
    public CodigoBanco?: number,
    public NumeroCuenta?: string,
    public TipoCuenta?: number,
    public Actualizar?: boolean,
    public NombreTitularCuenta?: string,
    public CedulaTitularCuenta?: string,
    public CorreoTitularCuenta?: string,
    public CorreoTitular?: string,
    public TelefonoTitular?: string,
    public NombreRepresentante?: string,
    public MailRepresentante?: string,
    public CelularRepresentante?: string,
    public CedulaRepresentante?: string,
    public NombreCompletoTitular?: string,
    public CedulaTitular?: string
  ) {}
}

export class Reclamo {
  constructor(
    public CodigoCliente?: number,
    public CodigoCiudad?: number,
    public Unidad?: number,
    public CodigoTitular?: number,
    public TipoPaciente?: number, ///1 Titular 2 Dependiente
    public TipoReclamo?: number,
    public Platitcod?: number,
    public Placod?: number,
    public Aseguradora?: number,
    public Ramo?: string,
    public DocumentosReclamo?: DocumentoReclamo[],
    public TipoNegocio?: number, ///1 aseguradora 2 manejo directo
    public CodigoDependiente?: number,
    public NombrePaciente?: string,
    public AppOrigen?: number, /// 1 tecni en línea
    public Poliza?: string,
    public CodigoTracking?: number, /// esto retorna no hay q mandar
    public DocumentacionCompleta?: boolean, /// si ha adjuntado todo lo que le manda =/
    public CodigoDiagnostico?: number,
    public ValorPresentado?: number,
    public TelefonoTitular?: string,
    public EmailTitular?: string,
  ) {}
}

export class DocumentoReclamo {
  constructor(
    public Codigo?: number, // añadido
    public TipoDocumento?: number,
    public Archivo?: File, // añadido
    public NombreArchivo?: string,
    public TipoMIME?: string,
    public ArchivoByte?: any, // byte[]
    public AdjuntoString?: string
  ) {}
}

export class DocumentosPorAseguradora {
  constructor(
    public codigoDocumento?: number,
    public TipoDoc?: string,
    public TipCod?: number,
    public NombreDocumento?: string,
    public EsFormulario?: boolean,
    public TieneFormulario?: boolean
  ) {}
}

export class TipRcl {
  constructor(
    public TipCod?: number,
    public TipDes?: string,
    public TipNeg?: number,
    public RamCod?: string
  ) {}
}

export class InfoPersona {
  constructor(
    public CoidgoCiudad?: number,
    public CodigoCliente?: number,
    public CodigoPersona?: number,
    public CodigoUnidad?: number,
    public CodigoTitular?: number,
    public TipoPersona?: number,
    public PlaCod?: number,
    public PlaTitCod?: number,
    public CodigoAseguradora?: number,
    public Ramo?: string,
    public TipoNegocio?: number,
    public NombrePersona?: string,
    public PolCod?: string
  ) {}
}

export class InfoPoliza {
  constructor(
    public CodigoCliente?: number,
    public CodigoCiudad?: number,
    public CodPoliza?: string,
    public CodAseguradora?: number,
    public CodRamo?: string,
    public TipoNegocio?: number,
    public TitCod?: number
  ) {}
}

export class DocumentoTracking {
  constructor(
    public CodigoSiniestro?: number,
    public TipoManejo?: number,
    public DocumentosReclamo?: DocumentoReclamo[]
  ) {}
}

export class DiagnosticoEntity {
  constructor(public DiaCod?: number, public Diagnostico?: string) {}
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/vam_entity.ts